import { makeStyles } from '@material-ui/styles';
import { grayColor, navyColor } from 'assets/jss/material-dashboard-pro-react';
import { useSelector } from 'react-redux';
import { type Brands as BrandsType } from 'types/Brands';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { currencyToSymbol } from 'utils/currencies';

const useStyles = makeStyles({
  headerWrapper: {
    marginBottom: '6px',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: '400',
    color: navyColor,
  },
  tooltip: {
    marginRight: '5px',
  },
  info: {
    marginLeft: '4px',
    paddingTop: '1px',
    fontSize: '16px',
    color: grayColor[1],
  },
});

type AdditionalMealTypesProps = {
  value: number;
};

const AdditionalMealTypes = ({ value }: AdditionalMealTypesProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const currency = useSelector(
    ({ Brands }: { Brands: BrandsType }) => Brands.brand.multinational.currency
  );

  return (
    <div className={classes.headerWrapper}>
      <span>{t('orders.additionalMealTypes')}:</span>
      <span>
        <Tooltip
          className={classes.tooltip}
          title={t('orders.summary.additionalMealTypes.tooltip')}
        >
          <Info className={classes.info} />
        </Tooltip>
        <span>{`${value.toFixed(2)} ${currencyToSymbol(currency)}`}</span>
      </span>
    </div>
  );
};

export default AdditionalMealTypes;
